import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { inject } from '@vercel/analytics';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Polyfill for Buffer (required by @react-pdf/renderer)
import { Buffer } from 'buffer';
window.Buffer = Buffer;

// Initialize Sentry for error monitoring
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.NODE_ENV,
  // Only send errors in production
  enabled: process.env.NODE_ENV === 'production',
  // Capture 10% of transactions for performance monitoring
  tracesSampleRate: 0.1,
  // Disable replay to avoid pageObserver error
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
  beforeSend(event) {
    // Scrub larceny report tokens from captured URLs
    const scrubToken = (str) =>
      typeof str === 'string' ? str.replace(/\/report\/[^/?#]+/, '/report/[token]') : str

    if (event.request?.url) {
      event.request.url = scrubToken(event.request.url)
    }
    if (Array.isArray(event.breadcrumbs?.values)) {
      event.breadcrumbs.values = event.breadcrumbs.values.map(b => ({
        ...b,
        data: b.data ? { ...b.data, url: scrubToken(b.data.url), to: scrubToken(b.data.to), from: scrubToken(b.data.from) } : b.data,
      }))
    }
    return event
  },
});

const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  // Dismiss splash screen once React has rendered
  const splash = document.getElementById('splash');
  if (splash) {
    splash.classList.add('hidden');
    splash.addEventListener('transitionend', () => splash.remove(), { once: true });
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
inject();
